module.exports = __webpack_public_path__ + "static/media/thumbnail1.3e50475c.jpg";